import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { CURRENT_API_URL_LIST } from "../../routes/current/index.js";
import  store  from '../../../state/store';

async function getList({params, body, urlSegments, loading}) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,loading);
}

async function getCurrentActionList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ACTION_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentActionDetailList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ACTION_DETAIL_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentActionDetailListTotal(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ACTION_DETAIL_LIST_TOTALS_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentApprovalList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_APPROVAL_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentOpenList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_OPEN_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentCodesList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_CODES_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getCurrentUnclosedInvoiceList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_UNCLOSED_INVOICE_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getSalesPersonList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.SALESPERSON_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getSingle(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.SINGLE_URL,params),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function addCurrent(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.ADD_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function approveAdminCurrent(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ADMIN_APPROVE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function approveAccountingCurrent(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ACCOUNTING_APPROVE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function rejectCurrent(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_REJECT_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function searchCurrent(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_SEARCH_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function getSeries(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_ACTION_DETAIL_SERIES_URL,params),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrencyCurrentList(params, body,urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_API_URL_LIST.CURRENT_CURRENCY_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request);
}
export {
    getList,
    getSalesPersonList,
    addCurrent,
    getSingle,
    getCurrentActionList,
    getCurrentUnclosedInvoiceList,
    getCurrentActionDetailList,
    getCurrentApprovalList,
    approveAdminCurrent,
    approveAccountingCurrent,
    rejectCurrent,
    getCurrentOpenList,
    getCurrentActionDetailListTotal,
    searchCurrent,
    getCurrentCodesList,
    getSeries,
    getCurrencyCurrentList,
};